import PropTypes from 'prop-types';

export const TierPricesDefaultProps = {
  tier_prices: [],
};

export const TierPricesPropTypes = {
  tier_prices: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.number,
      price: PropTypes.number,
    }),
  ),
};
